import React from 'react';
import {FastField} from 'formik';
import styles from './FormikDescription.module.scss';
import numeral from 'numeral';
import {TextField} from 'formik-material-ui';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

export interface IFormikDescriptionProps {
  name: string;
  values?: any;
  label?: any;

  additionalInfo?: string[] | string | any[] | any;
  maxLetters?: number;
  loading?: boolean;
  customCalculationText?: string;
}

export const generateAdditionalInfo = additionalInfo => (Array.isArray(additionalInfo) ? additionalInfo : [additionalInfo])
  .filter(a => a)
  .map((a, index) => <p key={index} className={styles.additionalInfo}>
    {a}
  </p>)

const FormikDescription = ({loading, ...props}: IFormikDescriptionProps) => {
  return loading ? <SkeletonPlaceHolder height={200}/> : (
    <>
      <FastField
        className={styles.FormikDescription}
        component={TextField}
        label={props.label}
        id={props.name}
        name={props.name}
        variant="outlined"
        multiline
        minRows={8}
        fullWidth/>
      <p className={styles.charactersAmount}>
        {props.customCalculationText || props.values[props.name] && (props.values[props.name].length ? `${numeral(props.values[props.name] && props.values[props.name].length).format("0,0")}/${numeral(props.maxLetters).format("0,0")}` : '')}
      </p>
      {generateAdditionalInfo(props.additionalInfo)}
    </>
  );
};

FormikDescription.defaultProps = {
  name: "",
  values: {},
  additionalInfo: [],

  maxLetters: 10000,
  customCalculationText: '',

};

export default React.memo(FormikDescription);
